/* eslint-disable no-unused-expressions */
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import PrevIcon from "../../../assets/prev.svg";
import NextIcon from "../../../assets/next.svg";
import { generateDate, months } from "../../../utils/calender";
import cn from "../../../utils/cn";
import {
  GetAvailability,
  GetBlockedDays,
  GetServiceProviderById,
} from "../../../utils/api";
import { useParams } from "react-router-dom";
import { message } from "antd";
import Loader from "../../shared/Loader";
import { formatTime } from "../../../utils/helper";

export default function Availability() {
  const { id: providerId } = useParams();
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const currentDate = dayjs();
  const [today, setToday] = useState(currentDate);
  const [selectDate, setSelectDate] = useState(currentDate);
  const [providerSlots, setProviderSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [blockedDays, setBlockedDays] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleDayClick = (date) => {
    setSelectDate(date);
    const selectedDay = date.format("dddd").toLowerCase();
    const selectedSlot = providerSlots?.find(
      (slot) => slot.name.toLowerCase() === selectedDay
    );
    setSelectedSlot(selectedSlot);
  };

  const getAvailability = async (userId) => {
    const response = await GetAvailability(userId);
    setProviderSlots(response?.items);
  };

  const getBlockedDays = async (userId) => {
    const response = await GetBlockedDays(userId);
    const datesArray = response?.items?.map((obj) => obj.date);
    setBlockedDays(datesArray);
  };

  useEffect(() => {
    const getServiceById = async () => {
      setLoading(true);
      try {
        const res = await GetServiceProviderById(providerId);
        if (res?.isSuccess) {
          getAvailability(res?.data?.user?.id);
          getBlockedDays(res?.data?.user?.id);
          setLoading(false);
        } else {
          message.error("Error while fetching details, Please try again");
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    };
    getServiceById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="bg-white flex mx-auto sm:flex-row flex-col poppins">
      <div className="shadow-md p-2 my-6 ml-6">
        <div className="flex gap-x-4 items-center pl-3">
          <h1 className="select-none font-bold  text-[#2D2D37]">
            {months[today.month()]} {today.year()}
          </h1>
          <div className="flex gap-x-1 items-center">
            <img
              src={PrevIcon}
              alt="prev-icon"
              className="cursor-pointer hover:scale-105 transition-all"
              onClick={() => {
                setToday(today.month(today.month() - 1));
              }}
            />
            {/* <h1
              className="text-xs cursor-pointer"
              onClick={() => {
                setToday(currentDate);
              }}
            >
              Today
            </h1> */}
            <img
              src={NextIcon}
              alt="next-icon"
              className="cursor-pointer hover:scale-105 transition-all"
              onClick={() => {
                setToday(today.month(today.month() + 1));
              }}
            />
          </div>
        </div>
        <div className="grid grid-cols-7">
          {days.map((day, index) => {
            return (
              <h1
                key={index}
                className="text-sm text-center h-12 w-12 grid place-content-center font-semibold text-gray-500 select-none text-[#343949]"
              >
                {day}
              </h1>
            );
          })}
        </div>
        {/*
        <div className="grid grid-cols-7">
          {generateDate(today.month(), today.year()).map(
            ({ date, currentMonth, today }, index) => {
              if (!currentMonth) {
                return <div className="h-12" />;
              }
              const isPastDate = date.isBefore(today, "day");

              if (isPastDate) {
                return <div className="h-12">{date.date()}</div>;
              }

              return (
                <div
                  key={index}
                  className="p-1 text-center h-12 grid place-content-center text-sm"
                >
                  <h1
                    className={cn(
                      today
                        ? "bg-[#E5B3B233] text-primary-600 border border-primary-600"
                        : "border-primary-600",
                      selectDate.toDate().toDateString() ===
                        date.toDate().toDateString()
                        ? "bg-[#E5B3B233] text-primary-600 border-2 border-primary-600"
                        : "border-primary-600",
                      providerSlots?.length &&
                        providerSlots?.some((slot) => {
                          if (
                            slot.providerAvailabilities &&
                            slot.providerAvailabilities.length > 0
                          ) {
                            return slot.providerAvailabilities.some(
                              (availability) => {
                                return (
                                  blockedDays.every(
                                    (day) => day !== date.format("YYYY-MM-DD")
                                  ) &&
                                  availability.dayName.toLowerCase() ===
                                    date.format("dddd").toLowerCase()
                                );
                              }
                            );
                          }
                          return false;
                        })
                        ? isPastDate
                          ? "bg-white text-gray-300 hover:bg-gray-200"
                          : "bg-primary-500 hover:bg-primary-600 text-white"
                        : "",

                      blockedDays.includes(date.format("YYYY-MM-DD"))
                        ? "bg-[#D04848] hover:bg-[#D04848] text-white hover:text-white cursor-not-allowed"
                        : "hover:bg-[#E5B3B233]",
                      isPastDate ? "text-lightGray bg-white" : "",
                      "h-8 w-8 rounded-full grid place-content-center transition-all cursor-pointer select-none"
                    )}
                    onClick={() => {
                      blockedDays?.includes(date.format("YYYY-MM-DD"))
                        ? undefined
                        : handleDayClick(date);
                    }}
                  >
                    {date.date()}
                  </h1>
                </div>
              );
            }
          )}
        </div> */}
        <div className="grid grid-cols-7">
          {generateDate(today.month(), today.year()).map(
            ({ date, currentMonth, today, isPastDate }, index) => {
              if (!currentMonth) {
                return <div key={index} className="h-12" />;
              }

              return (
                <div
                  key={index}
                  className={`p-1 text-center h-12 grid place-content-center text-sm ${
                    isPastDate ? "opacity-50" : ""
                  }`}
                >
                  <h1
                    className={cn(
                      today
                        ? "bg-[#E5B3B233] text-primary-600 border border-primary-600"
                        : "border-primary-600",
                      selectDate.toDate().toDateString() ===
                        date.toDate().toDateString()
                        ? "bg-[#E5B3B233] text-primary-600 border-2 border-primary-600"
                        : "border-primary-600",
                      !isPastDate &&
                        providerSlots?.length &&
                        providerSlots?.some((slot) => {
                          if (
                            slot.providerAvailabilities &&
                            slot.providerAvailabilities.length > 0
                          ) {
                            return slot.providerAvailabilities.some(
                              (availability) => {
                                return (
                                  blockedDays.every(
                                    (day) => day !== date.format("YYYY-MM-DD")
                                  ) &&
                                  availability.dayName.toLowerCase() ===
                                    date.format("dddd").toLowerCase()
                                );
                              }
                            );
                          }
                          return false;
                        })
                        ? `bg-primary-500 hover:bg-primary-600 text-white`
                        : "",
                      blockedDays?.includes(date.format("YYYY-MM-DD"))
                        ? "bg-[#D04848] hover:bg-[#D04848] text-white hover:text-white cursor-not-allowed"
                        : "hover:bg-[#E5B3B233]",
                      "h-8 w-8 rounded-full grid place-content-center transition-all cursor-pointer select-none"
                    )}
                    onClick={() => {
                      blockedDays?.includes(date.format("YYYY-MM-DD")) ||
                      isPastDate
                        ? undefined
                        : handleDayClick(date);
                    }}
                  >
                    {date.date()}
                  </h1>
                </div>
              );
            }
          )}
        </div>
      </div>

      <div className="sm:px-5 my-6">
        {selectedSlot ? (
          <h1 className="font-semibold text-[#2D2D37]">
            Availability for {selectDate.toDate().toDateString()}
          </h1>
        ) : (
          <h1 className="font-semibold text-[#2D2D37]">Please Select a date</h1>
        )}

        <div className="mt-2">
          {selectedSlot?.providerAvailabilities?.length ? (
            selectedSlot?.providerAvailabilities?.map((availability) => {
              return (
                <div
                  key={availability?.id}
                  className="inline-block bg-primary-500 rounded-lg px-3 py-1 text-primary-600 mr-3 mb-3"
                >
                  <span className="text-xs">
                    {formatTime(availability?.startTime)} -
                    {formatTime(availability?.endTime)}
                  </span>
                </div>
              );
            })
          ) : (
            <h1 className="font-semibold text-[#2D2D37]">
              {selectedSlot && "No Availability."}
            </h1>
          )}
        </div>
      </div>
    </div>
  );
}

// import dayjs from "dayjs";
// import React, { useEffect, useState } from "react";
// import PrevIcon from "../../../assets/prev.svg";
// import NextIcon from "../../../assets/next.svg";
// import { generateDate, months } from "../../../utils/calender";
// import cn from "../../../utils/cn";
// import {
//   GetAvailability,
//   GetBlockedDays,
//   GetServiceProviderById,
//   GetServicesForAvailability,
//   GetSlots,
// } from "../../../utils/api";
// import { useParams } from "react-router-dom";
// import { message } from "antd";
// import Loader from "../../shared/Loader";

// export default function Availability() {
//   const { id: providerId } = useParams();
//   const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
//   const currentDate = dayjs();
//   const [today, setToday] = useState(currentDate);
//   const [selectDate, setSelectDate] = useState(currentDate);
//   const [providerSlots, setProviderSlots] = useState([]);
//   const [selectedSlot, setSelectedSlot] = useState(null);
//   const [blockedDays, setBlockedDays] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [slotsLoading, setSlotsLoading] = useState(false);

//   const handleDayClick = (date) => {
//     if (!selectedService) {
//       if (services && services.length) {
//         return message.error("Please select a service.");
//       } else {
//         return message.error("No services available therefore no slots.");
//       }
//     }
//     setSelectDate(date);
//     const selectedDay = date.format("dddd").toLowerCase();
//     const selectedSlot = providerSlots?.find(
//       (slot) => slot.name.toLowerCase() === selectedDay
//     );
//     setSelectedSlot(selectedSlot);
//     getServicesSlots(
//       selectedService,
//       dayjs(date).format("YYYY-MM-DD"),
//       dayjs().format("HH:mm")
//     );
//   };

//   const getAvailability = async (userId) => {
//     const response = await GetAvailability(userId);
//     setProviderSlots(response?.items);
//   };

//   const getBlockedDays = async (userId) => {
//     const response = await GetBlockedDays(userId);
//     const datesArray = response?.items?.map((obj) => obj.date);
//     setBlockedDays(datesArray);
//   };

//   // New code
//   const [services, setServices] = useState([]);
//   const getServices = async (userId) => {
//     const response = await GetServicesForAvailability(userId);
//     setServices(response?.items);
//   };

//   const [serviceSlots, setServiceSlots] = useState([]);
//   const getServicesSlots = async (serviceId, date, currentTime) => {
//     setSlotsLoading(true);
//     try {
//       const response = await GetSlots({
//         serviceId,
//         date,
//         currentTime,
//       });
//       setServiceSlots(response?.items);
//       setSlotsLoading(false);
//     } catch (error) {
//       setSlotsLoading(false);
//     }
//   };

//   const [selectedService, setSelectedService] = useState(null);
//   const handleSelectedServiceChangeFn = (id) => {
//     setSelectedService(id);
//     setSelectedSlot(null);
//     setServiceSlots([]);
//     setSelectDate(currentDate);
//   };

//   useEffect(() => {
//     const getServiceById = async () => {
//       setLoading(true);
//       try {
//         const res = await GetServiceProviderById(providerId);
//         if (res?.isSuccess) {
//           getServices(res?.data?.user?.id);
//           getAvailability(res?.data?.user?.id);
//           getBlockedDays(res?.data?.user?.id);
//           setLoading(false);
//         } else {
//           message.error("Error while fetching details, Please try again");
//           setLoading(false);
//         }
//       } catch (error) {
//         setLoading(false);
//       }
//     };
//     getServiceById();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   if (loading) {
//     return <Loader />;
//   }

//   return (
//     <div className="bg-white flex mx-auto sm:flex-row flex-col poppins">
//       <div className="flex-2 shadow-md p-2 my-6 ml-6">
//         <div className="flex gap-x-4 items-center pl-3">
//           <h1 className="select-none font-bold  text-[#2D2D37]">
//             {months[today.month()]} {today.year()}
//           </h1>
//           <div className="flex gap-x-1 items-center">
//             <img
//               src={PrevIcon}
//               alt="prev-icon"
//               className="cursor-pointer hover:scale-105 transition-all"
//               onClick={() => {
//                 setToday(today.month(today.month() - 1));
//               }}
//             />
//             <img
//               src={NextIcon}
//               alt="next-icon"
//               className="cursor-pointer hover:scale-105 transition-all"
//               onClick={() => {
//                 setToday(today.month(today.month() + 1));
//               }}
//             />
//           </div>
//         </div>
//         <div className="grid grid-cols-7">
//           {days.map((day, index) => {
//             return (
//               <h1
//                 key={index}
//                 className="text-sm text-center h-12 w-12 grid place-content-center font-semibold text-gray-500 select-none text-[#343949]"
//               >
//                 {day}
//               </h1>
//             );
//           })}
//         </div>
//         <div className="grid grid-cols-7">
//           {generateDate(today.month(), today.year()).map(
//             ({ date, currentMonth, today, isPastDate }, index) => {
//               if (!currentMonth) {
//                 return <div key={index} className="h-12" />;
//               }

//               return (
//                 <div
//                   key={index}
//                   className={`p-1 text-center h-12 grid place-content-center text-sm`}
//                 >
//                   <h1
//                     className={cn(
//                       today
//                         ? "bg-[#E5B3B233] text-primary-600 border border-primary-600"
//                         : "border-primary-600",
//                       selectDate.toDate().toDateString() ===
//                         date.toDate().toDateString()
//                         ? "bg-[#E5B3B233] text-primary-600 border-2 border-primary-600"
//                         : "border-primary-600",
//                       // !isPastDate &&
//                       //   providerSlots?.length &&
//                       //   providerSlots?.some((slot) => {
//                       //     if (
//                       //       slot.providerAvailabilities &&
//                       //       slot.providerAvailabilities.length > 0
//                       //     ) {
//                       //       return slot.providerAvailabilities.some(
//                       //         (availability) => {
//                       //           return (
//                       //             blockedDays.every(
//                       //               (day) => day !== date.format("YYYY-MM-DD")
//                       //             ) &&
//                       //             availability.dayName.toLowerCase() ===
//                       //               date.format("dddd").toLowerCase()
//                       //           );
//                       //         }
//                       //       );
//                       //     }
//                       //     return false;
//                       //   })
//                       //   ? `bg-primary-500 hover:bg-primary-600 text-white`
//                       //   : "",
//                       !isPastDate &&
//                         providerSlots?.length &&
//                         providerSlots?.some((slot) => {
//                           if (
//                             slot.providerAvailabilities &&
//                             slot.providerAvailabilities.length > 0
//                           ) {
//                             return slot.providerAvailabilities.some(
//                               (availability) => {
//                                 return (
//                                   blockedDays.every(
//                                     (day) => day !== date.format("YYYY-MM-DD")
//                                   ) &&
//                                   availability.dayName.toLowerCase() ===
//                                     date.format("dddd").toLowerCase()
//                                 );
//                               }
//                             );
//                           }
//                           return false;
//                         })
//                         ? `bg-primary-500 hover:bg-primary-600 text-white`
//                         : "",
//                       blockedDays?.includes(date.format("YYYY-MM-DD"))
//                         ? "hover:bg-[lightGray] text-black-300 hover:text-white cursor-not-allowed"
//                         : "",
//                       "h-8 w-8 rounded-full grid place-content-center transition-all cursor-pointer select-none"
//                     )}
//                     onClick={() => {
//                       blockedDays?.includes(date.format("YYYY-MM-DD")) ||
//                       isPastDate
//                         ? undefined
//                         : handleDayClick(date);
//                     }}
//                   >
//                     {date.date()}
//                   </h1>
//                 </div>
//               );
//             }
//           )}
//         </div>
//       </div>

//       <div className="flex-1 sm:px-5 my-6">
//         <div className="flex gap-8 flex-wrap">
//           {!!services?.length ? (
//             services.map((item, index) => {
//               return (
//                 <div className="flex flex-col" key={index}>
//                   <span className="text-sm font-semibold text-primary-900 mb-2">
//                     {item.name}
//                   </span>
//                   <div className="flex gap-2 flex-wrap">
//                     {!!item?.services?.length &&
//                       item?.services?.map((sub, i) => {
//                         return (
//                           <span
//                             key={i}
//                             onClick={() =>
//                               handleSelectedServiceChangeFn(sub?.id)
//                             }
//                             className={`w-max cursor-pointer text-xs border border-primary-900  py-0.5 px-2 rounded-full ${
//                               sub?.id === selectedService
//                                 ? "bg-primary-500"
//                                 : "bg-primary-300"
//                             }`}
//                           >
//                             {sub?.title}
//                           </span>
//                         );
//                       })}
//                   </div>
//                 </div>
//               );
//             })
//           ) : (
//             <h1 className="font-semibold text-[#2D2D37]">
//               No Services Avaliable.
//             </h1>
//           )}
//         </div>

//         <div className="mt-2">
//           {selectedSlot ? (
//             <h1 className="font-semibold text-[#2D2D37]">
//               Time Slots for {selectDate.toDate().toDateString()}
//             </h1>
//           ) : (
//             <h1 className="font-semibold text-[#2D2D37]">
//               {!!services?.length &&
//                 (!selectedService
//                   ? "Please Select a service and date"
//                   : "Please select date")}
//             </h1>
//           )}
//         </div>
//         {slotsLoading ? (
//           <Loader height="h-[40vh]" />
//         ) : (
//           <div className="mt-2">
//             {!!serviceSlots?.length ? (
//               serviceSlots?.map((slot, index) => {
//                 return (
//                   <div
//                     key={index}
//                     className="inline-block bg-primary-500 rounded-lg px-3 py-1 text-primary-600 mr-3 mb-3"
//                   >
//                     <span className="text-xs">
//                       {slot?.startTime} - {slot?.endTime}
//                     </span>
//                   </div>
//                 );
//               })
//             ) : (
//               <h1 className="font-semibold text-[#2D2D37]">
//                 {selectedSlot && "No Time Slots Avaliable."}
//               </h1>
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }
